/**
 * useOperationsSummary Hook — G-12
 *
 * 首頁與今日工作台指標的權威聚合來源。改呼叫後端 SQL 聚合端點
 * （GET /api/reports/operations-summary），指標不再從受 LIMIT 500 限制的
 * 訂單清單自行 count/sum，訂單量成長後仍精確。
 *
 * 僅 admin / staff 可讀（與後端 requireRole 一致）。本 hook 不自行依角色
 * gate 查詢（enabled 預設為 true）——driver 無法觸發它是因為 /manage 路由層
 * 已由 App.tsx 的 RequireAuth（roles=["admin","staff"]）擋下，driver 根本
 * 到不了掛載此 hook 的頁面。若未來有新呼叫端可能讓 driver 觸達，須自行傳入
 * `{ enabled: false }`，不能假設本 hook 會自動退回 0。
 */

import { useQuery } from "@tanstack/react-query";
import { apiRequest } from "@/lib/queryClient";
import type { OperationsSummary } from "@/lib/types";

export const OPERATIONS_SUMMARY_KEY = "/api/reports/operations-summary";

export function useOperationsSummary(options: { enabled?: boolean } = {}) {
  const { enabled = true } = options;

  return useQuery<OperationsSummary>({
    queryKey: [OPERATIONS_SUMMARY_KEY],
    enabled,
    queryFn: async () => {
      const res = await apiRequest("GET", OPERATIONS_SUMMARY_KEY);
      return (await res.json()) as OperationsSummary;
    },
  });
}
